import { store } from '@/main'
import { DATE_TIME_FORMAT, DATE_FORMAT } from 'CORE/utils/date'
import _ from 'lodash'
import moment from 'moment'

export const ftsByDataType = (value, dataType) => {
    const rawValue = _.get(value, 'value.value')
    const numValue = _.get(value, 'value.value.number')
    switch (dataType) {
        case 'BOOLEAN':
            return rawValue ? 'ano' : 'ne'
        case 'NUMERIC':
            try {
                return numValue.toString()
            } catch (e) {
                return undefined
            }
        case 'LINK_PERSON_RESOURCE':
            return _.join(_.map(rawValue, v => _.trim(_.join(_.filter(_.map(['system-jmeno', 'system-prijmeni', 'system-name'], pn => {
                return _.get(store.getters.resourceById(v), `propertyValues.${pn}.value.value`, undefined)
            }), _.size), ' '))), ' ')
        case 'DATE_TIME':
            return moment(rawValue, 'X').format(DATE_TIME_FORMAT)
        case 'DATE':
            return moment(rawValue, 'X').format(DATE_FORMAT)
        case 'ENTITY_STATE':
            try {
                const graph = _.find(_.get(store.getters.currentUser, `company.settings.entity-states.states`, {}), ['id', rawValue])
                return graph.label
            } catch (e) {
                return undefined
            }
        case 'LINK_USER':
            return _.map(rawValue, v => {
                return _.get(store.getters.userById(v), 'username', '')
            }).join(' ')
        case 'ENUM':
        case 'STATIC_STRING':
        default:
            return rawValue
    }
}

export const sorterByDataType = (value, dataType) => {
    const rawValue = _.get(value, 'value.value')
    const numValue = _.get(value, 'value.value.number')
    switch (dataType) {
        case 'NUMERIC':
            return numValue
        case 'BOOLEAN':
            return rawValue
        case 'DATE_TIME':
        case 'DATE':
            return rawValue
        case 'ENTITY_STATE':
            try {
                const graph = _.find(_.get(store.getters.currentUser, `company.settings.entity-states.states`, {}), ['id', rawValue])
                return graph.label
            } catch (e) {
                return ''
            }
        case 'LINK_USER':
            return _.map(rawValue, v => {
                return _.get(store.getters.userById(v), 'username', '')
            }).join(' ')
        default:
            return ftsByDataType(value, dataType)
    }
}

export const normalizeFts = _.flow([
    _.deburr,
    _.toLower,
])
